// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox--12BvG","checkbox_box":"checkbox_box--VfGHz","active":"active--2la4H"};